'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["property", "onInsert", "fetchPaths", "dataTokenConfig"];
import PopoverContent from 'data-token-picker/components/PopoverContent';
import { usePaths } from '../personalize/hooks/usePaths';
import { RequestStatus } from '../../api/constants';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Fieldset } from 'foundations-components/transitional/components/Fieldset';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
function DataTokenPopoverBodyInsert(_ref) {
  let {
      property,
      onInsert,
      fetchPaths,
      dataTokenConfig
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const settingsLink = dataTokenConfig.isEmail ? rest.emailSettingsLink : rest.publishingSettingsLink;
  const {
    category,
    field,
    subCategory
  } = property || {};
  const [{
    categories,
    fieldsByCategory
  }, pathsRequestStatus] = usePaths(fetchPaths, dataTokenConfig);
  const allowEmptyFallbacks = dataTokenConfig.allowEmptyFallbacks === undefined ? true : dataTokenConfig.allowEmptyFallbacks;
  const propertiesLoading = pathsRequestStatus === RequestStatus.PENDING || pathsRequestStatus === RequestStatus.UNINITIALIZED;
  if (propertiesLoading) {
    return /*#__PURE__*/_jsx(View, {
      inlineSize: "325px",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        layout: "centered",
        minHeight: 300
      })
    });
  }
  return /*#__PURE__*/_jsx(Fieldset, {
    _size: "small",
    children: /*#__PURE__*/_jsx(PopoverContent, Object.assign({
      category: category,
      categories: categories,
      field: subCategory ? `${field}.${subCategory}` : field,
      fieldsByCategory: fieldsByCategory,
      allowEmptyFallbacks: allowEmptyFallbacks,
      hideFallbacks: dataTokenConfig && dataTokenConfig.hideFallbacks,
      onConfirm: onInsert,
      settingsLink: settingsLink
    }, rest))
  });
}
DataTokenPopoverBodyInsert.displayName = 'DataTokenPopoverBodyInsert';
export default DataTokenPopoverBodyInsert;